import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/feedback/import';
import NavPanel from '@/components/common/NavPanel.vue';
import CommonConfig from '@/common/CommonConfig';
import SVGA from 'svgaplayerweb';
var FeedbackView = /** @class */ (function (_super) {
    __extends(FeedbackView, _super);
    function FeedbackView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 2022/2/15 14:32 升级的数据
        _this.upgradeList = CommonConfig.Common.upLevelList;
        // 2022/3/22 11:18 当前权益
        _this.currentEquity = CommonConfig.Common.currentEquity;
        // 2022/3/22 10:10 女神行为规范
        _this.levelText = [
            '不上线，-40魅力值/天',
            '超时不回复对方消息，-1.2魅力值/条',
            '拒接音视频通话，-4魅力值/通',
            '超时不接听音视频通话，-1.2魅力值/通',
            '主动挂断音视频通话，-4魅力值/通',
            '被举报，扣大量魅力值',
        ];
        // 2022/3/22 10:10 是否展示升级的tip
        _this.isShowTip = false;
        // 2022/3/22 10:10 女神的详情
        _this.nobilityInfo = {};
        _this.APPRoutes = CommonConfig.Common.APPRoutes;
        // 2022/3/28 14:29 评星
        _this.rate = 2.3;
        _this.maxRate = 0;
        _this.bgColor = ['#C7E5C2', '#93C688'];
        // 顶部 nav 背景色：默认透明，滚动超过阈值后切到 #fff，让标题在白底上更清晰
        _this.navBg = 'transparent';
        _this.scrollEl = null;
        _this.NAV_BG_THRESHOLD = 60;
        // 滚动联动：> 阈值 → 白底；回到顶部 → 透明
        _this.onContentScroll = function () {
            if (!_this.scrollEl)
                return;
            var top = _this.scrollEl.scrollTop || 0;
            _this.navBg = top > _this.NAV_BG_THRESHOLD ? '#fff' : 'transparent';
        };
        return _this;
    }
    FeedbackView.prototype.created = function () {
        var _this = this;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.getUserLevel();
        this.globalCommit('setting_pageJump', 1);
    };
    FeedbackView.prototype.mounted = function () {
        var _this = this;
        // NavPanel 内部 .nav-content 是真正的滚动容器（外层 .nav-box 是 100vh + flex），监听它的 scroll
        this.$nextTick(function () {
            var root = _this.$refs.navPanelRef && _this.$refs.navPanelRef.$el;
            var el = root && root.querySelector ? root.querySelector('.nav-content') : null;
            if (!el)
                return;
            _this.scrollEl = el;
            el.addEventListener('scroll', _this.onContentScroll, { passive: true });
        });
    };
    FeedbackView.prototype.unmounted = function () {
        if (this.scrollEl) {
            this.scrollEl.removeEventListener('scroll', this.onContentScroll);
            this.scrollEl = null;
        }
        this.clearAni();
    };
    // 2022/3/22 10:09 获取用户的等级
    FeedbackView.prototype.getUserLevel = function () {
        var _this = this;
        PageService.getGoddessInfo({}).then(function (data) {
            _this.nobilityInfo = data;
            if (data.avatarFrameSvg) {
                setTimeout(function () {
                    _this.playAni();
                }, 100);
            }
            // 背景颜色
            console.log('currentLevel', data.currentLevel.substring(3, data.currentLevel.length));
            var level = Number(data.currentLevel.substring(3, data.currentLevel.length));
            switch (level) {
                case 0:
                    _this.bgColor = ['#C7E5C2', '#93C688'];
                    break;
                case 1:
                    _this.bgColor = ['#C7E5C2', '#93C688'];
                    break;
                case 2:
                    _this.bgColor = ['#A2EBC4', '#4EB381'];
                    break;
                case 3:
                    _this.bgColor = ['#94DDF7', '#59B6D3'];
                    break;
                case 4:
                    _this.bgColor = ['#A6E0FF', '#48B0FF'];
                    break;
                case 5:
                    _this.bgColor = ['#D9E1FF', '#8892F3'];
                    break;
                case 6:
                    _this.bgColor = ['#FFC5CB', '#EA51C6'];
                    break;
                case 7:
                    _this.bgColor = ['#EDC2FC', '#B871FF'];
                    break;
                case 8:
                    _this.bgColor = ['#FFE4AE', '#FF3FBE'];
                    break;
                case 9:
                    _this.bgColor = ['#FFBBBB', '#FF3729'];
                    break;
                default:
                    _this.bgColor = ['#FFEB60', '#FF3500'];
                    break;
            }
            _this.maxRate = Math.ceil(data.star);
        });
    };
    // 2022/5/10 10:57 播放头像框svg
    FeedbackView.prototype.playAni = function () {
        var _this = this;
        if (this.player) {
            this.player.clear();
        }
        this.player = new SVGA.Player('#svgBorder');
        var parser = new SVGA.Parser();
        parser.load(this.nobilityInfo.avatarFrameSvg, function (videoItem) {
            {
                _this.player.setVideoItem(videoItem);
                _this.player.startAnimation();
            }
        });
    };
    // 2022/3/22 10:48 当前权益
    FeedbackView.prototype.toPage = function (index) {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/currentEquity',
            query: {
                activeName: index,
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            },
        });
        // this.getRoute();
    };
    // 2022/3/28 14:46 跳转记录页面
    FeedbackView.prototype.toRecord = function () {
        this.$router.push({
            path: '/nav/levelRecord',
            query: {
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            },
        });
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
    };
    // 2022/3/28 15:27 跳转APP页面
    FeedbackView.prototype.toNativePage = function (url) {
        var params = {
            action: 0,
            route: url,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    // 2022/3/28 15:36 原生调用H5方法
    FeedbackView.prototype.doReloadData = function () {
        this.getUserLevel();
    };
    // 2022/5/11 18:12 清除动画
    FeedbackView.prototype.clearAni = function () {
        if (this.player) {
            this.player.clear();
        }
    };
    FeedbackView = __decorate([
        Options({
            components: {
                NavPanel: NavPanel,
            },
        })
    ], FeedbackView);
    return FeedbackView;
}(AvalonGTView.BaseView));
export default FeedbackView;
